import { Link } from "@tanstack/react-router";

import LogoWL from "~/assets/logo_wl.svg";
import { Button } from "@workspace/web-ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@workspace/web-ui/components/dialog";

import { useContinueNotModal } from "../pages/welcome/store/use-continue-not-store";

type ContinueNotModalProps = {
  text: string;
}

export function ContinueNotModal({ text }: ContinueNotModalProps) {
  const { isOpen, close } = useContinueNotModal();

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-xs rounded-[24px] px-4 pb-8 pt-6 sm:max-w-sm sm:px-8 sm:pb-10 sm:pt-8 md:max-w-xl lg:px-[64px] lg:pb-[60px] lg:pt-[40px] xl:max-w-[700px]">
        <div
          className="flex shrink-0 items-center justify-center"
          aria-hidden="true"
        >
          <Link to="/" className="mx-auto mb-4 sm:mb-6 lg:mb-[24px]">
            <img src={LogoWL} alt="Proxymed logo" className="w-32 sm:w-auto" />
          </Link>
        </div>
        <div className="flex flex-col items-center gap-2 xl:mb-[48px]">
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-bold sm:text-3xl lg:text-[40px] xl:mb-[16px]">
              Sorry, We Can’t Continue
            </DialogTitle>
            <DialogDescription className="text-center text-base leading-[27px] sm:text-lg">
              <p>
                {text}
              </p>
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="mb-[24px]">
          <Button
            type="button"
            className="h-12 sm:h-[50px] lg:h-[57px]"
            fullWidth
            size="xl"
            onClick={close}
          >
            Okay
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
